import {router} from '@/integrations/router'

window.onALinkClick = onALinkClick

const STATIC_DOMAIN = 'taptiq.com'
const META_SUBDOMAIN = getSubdomain()

function getSubdomain() {
  const metaTag = document.querySelector('meta[name="app-domain"]')
  return metaTag ? metaTag.getAttribute('content') : ''
}

function getFullSubdomain() {
  const isDev = window.location.hostname.includes('.dev.')
  return isDev ? `${META_SUBDOMAIN}.dev` : META_SUBDOMAIN
}

const currentOrigin = `https://${getFullSubdomain()}.${STATIC_DOMAIN}`

function onALinkClick(e) {
  const target = findAnchorElement(e.target)
  if (!target) return

  const quill = document.querySelector('.ql-editor')
  if (quill && quill.contains(target)) return

  const rawHref = target.getAttribute('href') || ''
  if (!shouldProcessLink(rawHref, target, e)) return

  e.preventDefault()
  processNavigation(rawHref, target)
}

document.addEventListener('click', e => onALinkClick(e))

function findAnchorElement(element) {
  while (element && element.tagName !== 'A') {
    element = element.parentElement
    if (!element) return null
  }
  return element
}

function shouldProcessLink(rawHref, anchorElement, event) {
  if (!rawHref || rawHref.startsWith('#')) return false
  if (rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) return false
  if (anchorElement.hasAttribute('download')) return false
  if (event.ctrlKey || event.shiftKey || event.metaKey || event.altKey) return false
  return true
}

function processNavigation(rawHref, anchorElement) {
  try {
    // Относительные пути всегда через роутер
    if (rawHref.startsWith('/')) {
      router.push(rawHref)
      return
    }

    const href = normalizeHref(rawHref)
    const url = new URL(href)
    const isInternal = url.origin === currentOrigin
    const wantsNewTab = anchorElement.getAttribute('target') === '_blank'

    // Внутренние ссылки - всегда через роутер (игнорируем target="_blank")
    if (isInternal) {
      router.push(url.pathname + url.search + url.hash)
    }
    // Внешние ссылки с target="_blank" - открываем в новой вкладке
    else if (wantsNewTab) {
      window.open(url.href, '_blank', 'noopener,noreferrer')
    }
    // Внешние ссылки без target="_blank" - обычный переход
    else {
      window.location.href = url.href
    }
  } catch (error) {
    console.error('Navigation error:', error)
    window.location.href = rawHref
  }
}

function normalizeHref(rawHref) {
  if (/^https?:\/\//i.test(rawHref)) return rawHref
  if (rawHref.startsWith('//')) return window.location.protocol + rawHref
  if (/^[a-z0-9-]+\.[a-z]{2,}/i.test(rawHref.split('/')[0])) {
    return 'https://' + rawHref
  }
  return new URL(rawHref, currentOrigin).href
}
